"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespaceContext = void 0;
var _react = require("react");
/**
 * Interface representing the context for a translation namespace.
 */

/**
 * Default values for the `TranslationsNamespaceContext`.
 */
const defaultValues = {
  namespace: ''
};

/**
 * Context for managing the current translation namespace.
 */
const translationsNamespaceContext = exports.translationsNamespaceContext = /*#__PURE__*/(0, _react.createContext)(defaultValues);
//# sourceMappingURL=translationsNamespaceContext.js.map